// KPI Builder — the columns of a learner list. Shapes of the live “Students Enrolled - Detail” tables.
import { NAME_SCRIPT } from 'constants/kpiBuilderCatalogue';
import { Column, EsNode } from './types';

const DATE_FORMAT = "java.time.format.DateTimeFormatter.ofPattern('dd MMM yyyy')";
const dateScript = (field: string): string =>
  `doc['${field}'].size()==0?'':java.time.Instant.ofEpochMilli(doc['${field}'].value).atZone(java.time.ZoneId.of('Z')).format(${DATE_FORMAT})`;

/** The one aggregation that gives a column its value. */
function columnAgg(col: Column): EsNode {
  if (col.kind === 'count') return { cardinality: { field: col.field } };
  if (col.kind === 'date') return { terms: { script: { source: dateScript(col.field as string), lang: 'painless' }, size: 1, order: { max_ts: 'desc' } }, aggs: { max_ts: { max: { field: col.field } } } };
  return col.script ? { terms: { script: { source: NAME_SCRIPT, lang: 'painless' }, size: 1 } } : { terms: { field: col.field, size: 1 } };
}

/** The first date column decides the order of the rows, newest first, as in the live tables. */
export const sortColumn = (cols: Column[]): Column | undefined => cols.find((c) => c.kind === 'date');

/** One sub-aggregation per column, so each learner row carries those values. */
export function columnAggs(cols: Column[]): { sub: Record<string, EsNode>; types: Record<string, string>; order?: Record<string, string> } {
  const sub: Record<string, EsNode> = {};
  const types: Record<string, string> = {};
  cols.forEach((col) => {
    types[col.label] = col.kind === 'count' ? 'number' : 'text';
    sub[col.label] = columnAgg(col);
  });
  const latest = sortColumn(cols);
  if (latest) sub.latest_ts = { max: { field: latest.field } };
  return { sub, types, order: latest ? { latest_ts: 'desc' } : undefined };
}
